import { FC } from 'react'
import {
  Show,
  SimpleShowLayout,
  EditButton,
} from 'react-admin'
import { ActionsToolbar } from '../../components'
import LastUpdated from './LastUpdated'
import ObjectionTitle from './ObjectionTitle'
import CertificateForm from './CertificateForm'


const CertificateShow: FC = () => (
  <Show
    actions={<ActionsToolbar>
      <LastUpdated/>
      <ObjectionTitle />
      <EditButton variant="contained" label="resources.certificates.edit" />
    </ActionsToolbar>}
  >
    <SimpleShowLayout>
      <CertificateForm />
    </SimpleShowLayout>
  </Show>
)

export default CertificateShow